import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Divider,
  Button,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import CustomOverlay from "../components/CustomOverlay";
import { Auth, API } from "aws-amplify";
import { getSeller } from "../graphql/queries";

const HomePage = () => {
  const [overlay, setOverlay] = useState(true);
  const [showCreateProductBtn, setShowCreateProductBtn] = useState(false);
  const [showRegistrationBtn, setShowRegistrationBtn] = useState(false);
  const [showConnectBtn, setShowConnectBtn] = useState(false);

  useEffect(() => {
    const fetchSellerInfo = async () => {
      try {
        const currentUserInfo = await Auth.currentAuthenticatedUser();
        const response = await API.graphql({
          query: getSeller,
          variables: { id: currentUserInfo.attributes.sub },
          authMode: "AMAZON_COGNITO_USER_POOLS",
        });

        const seller = response.data.getSeller;

        if (!seller) {
          setShowRegistrationBtn(true);
        } else if (!seller.stripeID) {
          setShowConnectBtn(true);
        } else {
          setShowCreateProductBtn(true);
        }
      } catch (error) {
        console.error("getSeller エラー:", error);
        setShowRegistrationBtn(true);
      } finally {
        setOverlay(false);
      }
    };

    fetchSellerInfo();
  }, []);

  return (
    <>
      <CustomOverlay overlay={overlay} />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "16px" }}>
            ピッタプットは、
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "16px" }}>
            オンライン決済システム{" "}
            <Typography
              component="a"
              href="https://stripe.com/jp"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue", textDecoration: "underline" }}
            >
              Stripe（ストライプ）
            </Typography>{" "}
            と連携することで、
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: "16px" }}>
            簡単にデジタルコンテンツの販売が行えます。
          </Typography>
        </Grid>
      </Grid>

      <Divider style={{ margin: "16px 0" }} />

      <Typography variant="body1" style={{ marginBottom: "8px" }}>
        Stripeは複数のクレジットカードに対応しています。
      </Typography>
      <Typography variant="body2" style={{ marginBottom: "8px" }}>
        対応クレジットカード： VISA、MASTER、AMEX、JCB、Diners
      </Typography>
      <Typography variant="body2" style={{ marginBottom: "8px" }}>
        ピッタプット利用料（200円）、Stripeの決済手数料（一律3.6%）が各決済の売上から引かれます。
      </Typography>
      <Typography variant="body2" style={{ marginBottom: "8px" }}>
        入金サイクル：週ごとの指定曜日（初期設定：金曜日）または毎月の指定日付
      </Typography>

      <Divider style={{ margin: "16px 0" }} />

      {showRegistrationBtn && (
        <Box textAlign="center" style={{ marginTop: "16px" }}>
          <Typography variant="body1" style={{ marginBottom: "8px" }}>
            商品を作成するためには出品者情報の登録を行う必要があります。
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "16px" }}>
            下記より出品者情報の登録ページに移動してください。
          </Typography>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/profile/seller/new"
          >
            出品者情報を登録する
          </Button>
        </Box>
      )}

      {showConnectBtn && (
        <Box textAlign="center" style={{ marginTop: "16px" }}>
          <Typography variant="body1" style={{ marginBottom: "8px" }}>
            出品者情報の登録を確認しました。
          </Typography>
          <Typography variant="body1" style={{ marginBottom: "16px" }}>
            Stripeとの連携が必要です。下記ボタンから連携を行ってください。
          </Typography>
          <a
            href="https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_HMjw0lVlIUzcj0RMFSgE5sfRkizhNDsC&scope=read_write"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/image/stripe_manual/ConnectStripe.png"
              alt="Stripeと連携"
              style={{ maxWidth: "300px" }}
            />
          </a>
        </Box>
      )}

      {showCreateProductBtn && (
        <Box textAlign="center" style={{ marginTop: "16px" }}>
          <Typography variant="body1" style={{ marginBottom: "8px" }}>
            出品者情報の確認ができました。Stripeとの連携が確認できました。
          </Typography>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/products/new"
          >
            商品を作成する
          </Button>
        </Box>
      )}

      <Box textAlign="center" style={{ marginTop: "32px" }}>
        <Typography variant="body1" style={{ marginBottom: "8px" }}>
          ピッタプットではサービス改善に向けてのご意見・ご要望を募集しています。
        </Typography>
        <Button
          variant="contained"
          color="primary"
          href="https://forms.gle/8zn5sGur5xPYq1YW8"
          target="_blank"
          rel="noopener noreferrer"
        >
          アンケートに回答する
        </Button>
      </Box>
    </>
  );
};

export default HomePage;
